__turbopack_context__.v({
  "entryLabel": "RepresentativeExampleList-module__5emTSW__entryLabel",
  "entryList": "RepresentativeExampleList-module__5emTSW__entryList",
  "entryValue": "RepresentativeExampleList-module__5emTSW__entryValue",
});
